import React from "react";

export default function ListItem({
  children,
  className,
  ...rest
}) {
  return (
    <div
      className={`d-flex ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}

